module.exports = "<div *ngIf=\"isSupported\" class=\"live-chat-container d-flex pr-15 mr-15\">\n  <div class=\"live-chat-icon-container\" [inlineSVG]='\"icon_chat.svg\"'></div>\n  <span class=\"live-chat-message-container aTwo themeLink d-flex\" data-slnm-ihg=\"LiveChatSID\">\n    <a (click)=\"openLiveChat()\" class=\"live-chat-link\" target=\"_blank\" data-slnm-ihg=\"LiveChatLinkSID\" [innerText]=\"messages['reservation.livechat.label']\"></a>\n  </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/main/webapp/stay-mgmt/app/components/live-chat/live-chat.component.html
// module id = ./src/main/webapp/stay-mgmt/app/components/live-chat/live-chat.component.html
// module chunks = 0